var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResponsiveDesignExpand1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "responsive-design-expand-1",
    clipPath: "url(#clip0_3055_46928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.124 14.375H18.124C18.4555 14.375 18.7735 14.2433 19.0079 14.0089C19.2423 13.7745 19.374 13.4565 19.374 13.125V1.875C19.374 1.54348 19.2423 1.22554 19.0079 0.991117C18.7735 0.756696 18.4555 0.625 18.124 0.625H3.12402C2.7925 0.625 2.47456 0.756696 2.24014 0.991117C2.00572 1.22554 1.87402 1.54348 1.87402 1.875V9.37917",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.87402 4.375H19.374",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.37402 11.875H1.87402C1.18367 11.875 0.624023 12.4346 0.624023 13.125V18.125C0.624023 18.8154 1.18367 19.375 1.87402 19.375H9.37402C10.0644 19.375 10.624 18.8154 10.624 18.125V13.125C10.624 12.4346 10.0644 11.875 9.37402 11.875Z",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.624023 14.375H10.624",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.12402 16.875H4.37402",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.87402 16.875H8.12402",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.37402 9.375V7.5C4.37402 7.33424 4.43987 7.17527 4.55708 7.05806C4.67429 6.94085 4.83326 6.875 4.99902 6.875H8.74902C8.91478 6.875 9.07375 6.94085 9.19096 7.05806C9.30817 7.17527 9.37402 7.33424 9.37402 7.5V9.375",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.249 6.875H12.499C12.1538 6.875 11.874 7.15482 11.874 7.5V11.25C11.874 11.5952 12.1538 11.875 12.499 11.875H16.249C16.5942 11.875 16.874 11.5952 16.874 11.25V7.5C16.874 7.15482 16.5942 6.875 16.249 6.875Z",
    stroke: "#0049EA",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3055_46928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveDesignExpand1);
export default __webpack_public_path__ + "static/media/responsive-design-expand-1.d201d5d78d06ee5bbc69c8d082be52ce.svg";
export { ForwardRef as ReactComponent };